
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorHelpIcon as ObiCursorHelpIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-help-icon.js';
 
 
 

 
 export const ObiCursorHelpIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-help-icon',
   elementClass: ObiCursorHelpIconElement,
   events: {
     
   }
  });
 
 